/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

// Actions
import { setSelectedQuantity } from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './usageFilter.styles';

const UsageFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const selectedQuantity = useSelector(
    (state: ApplicationState) => state.reports.selectedQuantity,
  );

  const handleQuantity = (quantity: any) => {
    dispatch(
      setSelectedQuantity({
        selectedQuantity: quantity,
      }),
    );
  };

  return (
    <Box component='div'>
      <Typography variant='h5' className={classes.periodLabel}>
        Escolha o número de utilizações do usuário para filtrar.
      </Typography>

      <TextField
        label='Número de utilizações'
        name='usage'
        fullWidth
        size='small'
        type='number'
        variant='outlined'
        onChange={(e) => handleQuantity(e.target.value)}
        value={selectedQuantity}
      />
    </Box>
  );
};

export { UsageFilter };
export default UsageFilter;
